import React from 'react';
import { Circle } from '@phosphor-icons/react';

import { Tooltip, TooltipContent, TooltipTrigger } from '../ui/tooltip';

import { dark } from '@/colors/dark';
import { Badge } from '@/components/ui/badge';
import { cn } from '@/lib/utils';

type Props = React.ComponentPropsWithRef<typeof Badge> & {
  streamName: string;
  dotColor?: string; // hex code from Platform
};

export const StreamBadge = React.forwardRef<HTMLDivElement, Props>(
  ({ className, streamName, dotColor = 'transparent', ...props }, ref) => {
    return (
      <Tooltip>
        <TooltipTrigger asChild>
          <div
            ref={ref}
            role="button"
            className={cn('flex items-center gap-1 rounded-full p-0', className)}
            tabIndex={0}
          >
            <Badge {...props} className="bg-surface rounded-full border border-dark-300 text-subtle">
              <span className="flex items-center gap-1">
                <Circle
                  size={8}
                  weight="bold"
                  className="!size-2 rounded-full"
                  style={{ backgroundColor: dotColor }}
                  color={dotColor === 'transparent' ? dark[300] : 'transparent'}
                />
                <span className="max-w-32 truncate inline-block">{streamName}</span>
              </span>
            </Badge>
          </div>
        </TooltipTrigger>
        <TooltipContent>{streamName}</TooltipContent>
      </Tooltip>
    );
  },
);

StreamBadge.displayName = 'StreamBadge';
